import React from "react";
import {
	NavArrow,
	NavLanguage,
	NavLanguageItem,
	NavLanguageItemLink,
	NavLanguageList,
	NavLanguageModal,
	NavLink,
} from "./styles";
import { Triangle, TriangleShadow } from "../../styles";

import setSession from "headFootServices/session";
import { LanguageInfo } from "headFootServices/header/header";

interface LanguageProps {
	/** 全部语言 */
	languages: LanguageInfo[];
	/** 用户当前语言 */
	userLanguage: Partial<LanguageInfo>;
	onChangeLanguage?: (lan?: string) => void;
}

interface LanguageState {
	/** 当前选择的语言 */
	newUserLanguage: Partial<LanguageInfo>;
}

class Language extends React.Component<LanguageProps, LanguageState> {
	constructor(props) {
		super(props);
		this.state = {
			newUserLanguage: props.userLanguage,
		};
	}
	componentDidUpdate(prevProps: LanguageProps) {
		const { userLanguage } = this.props;
		if (prevProps.userLanguage !== userLanguage) {
			this.setState({
				newUserLanguage: userLanguage,
			});
		}
	}

	/** 修改当前选择的语言 */
	onChangeUserLanguage = async (newLanInfo: LanguageInfo) => {
		console.log("this.props.onChangeLanguage", this.props.onChangeLanguage);
		await setSession({
			language: newLanInfo.language_code,
		});

		if (this.props.onChangeLanguage) {
			this.props.onChangeLanguage(newLanInfo.language_code);
		} else {
			location.reload();
		}
	};

	render() {
		const { languages, userLanguage } = this.props;
		return (
			<NavLanguage>
				<NavLink>{userLanguage?.language_text}</NavLink>
				<NavLanguageModal>
					<Triangle style={{ left: "70%" }} />
					<TriangleShadow style={{ left: "70%" }} />
					<NavLanguageList>
						{languages.map((item, index) => (
							<NavLanguageItem
								key={index}
								onClick={() => this.onChangeUserLanguage(item)}
							>
								<NavLanguageItemLink>{item?.language_text}</NavLanguageItemLink>
							</NavLanguageItem>
						))}
					</NavLanguageList>
				</NavLanguageModal>
				<NavArrow />
			</NavLanguage>
		);
	}
}

export default Language;
